const isTouchDevice = () => {
  return ('ontouchstart' in window) || (navigator.maxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0);
};

if (!customElements.get('custom-accordion')) {
  customElements.define(
    'custom-accordion',
    class CustomAccordion extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.items = this.querySelectorAll('.custom-accordion-item');

        const video = this.querySelector('video');
        if (video) {
          if (!isTouchDevice()) {
            video.controls = false;

            video.addEventListener('mouseenter', () => {
              video.controls = true;
            });

            video.addEventListener('mouseleave', () => {
              video.controls = false;
            });
          } else {
            video.controls = true;
          }
        }

        this.items.forEach(item => {
          const button = item.querySelector('.custom-accordion-title');
          const content = item.querySelector('.custom-accordion-content');

          button.addEventListener('click', () => {
            const isOpen = button.getAttribute('aria-expanded') === 'true';

            if (isOpen) {
              content.style.maxHeight = null;
              content.setAttribute('aria-hidden', 'true');
              button.setAttribute('aria-expanded', 'false');
              item.classList.remove('open');
            } else {
              this.items.forEach(openItem => {
                if (openItem !== item) {
                  const openButton = openItem.querySelector('.custom-accordion-title');
                  const openContent = openItem.querySelector('.custom-accordion-content');
                  openContent.style.maxHeight = null;
                  openContent.setAttribute('aria-hidden', 'true');
                  openButton.setAttribute('aria-expanded', 'false');
                  openItem.classList.remove('open');
                }
              });

              content.style.maxHeight = content.scrollHeight + 'px';
              content.setAttribute('aria-hidden', 'false');
              button.setAttribute('aria-expanded', 'true');
              item.classList.add('open');
            }
          });
        });
      }
    }
  );
}

document.addEventListener('click', (event) => {
  const stepButton = event.target.closest('[data-covers-step]');
  const back = event.target.closest('[data-covers-back]');
  if (!stepButton && !back) return;

  const root = (stepButton || back).closest('#accordion-content-covers');
  if (!root || root.dataset.coversAnimating === 'true') return;

  const menu = root.querySelector('[data-covers-view="menu"]');
  if (!menu) return;

  const step = stepButton ? stepButton.getAttribute('data-covers-step') : '';
  const detail = step ? root.querySelector(`[data-covers-view="${step}"]`) : null;
  if (step && !detail) return;

  const nextView = detail || menu;
  const current = root.querySelector('[data-covers-view]:not([hidden])');
  if (!current || current === nextView) return;

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduceMotion) {
    showCoversView(root, nextView);
    return;
  }

  slideCoversView(root, current, nextView, detail ? 'forward' : 'back');
});

function showCoversView(root, nextView) {
  const menu = root.querySelector('[data-covers-view="menu"]');
  menu.hidden = nextView !== menu;
  root.querySelectorAll('[data-covers-view]').forEach((view) => {
    if (view === menu) return;
    view.hidden = view !== nextView;
  });
  resizeCoversAccordion(root);
}

function slideCoversView(root, current, nextView, direction) {
  const stage = current.parentElement;
  root.dataset.coversAnimating = 'true';

  const fromHeight = current.offsetHeight;
  stage.style.position = 'relative';
  stage.style.overflow = 'hidden';
  stage.style.height = fromHeight + 'px';

  const enterFrom = direction === 'forward' ? '100%' : '-100%';
  const exitTo = direction === 'forward' ? '-100%' : '100%';

  nextView.hidden = false;
  nextView.style.cssText = `position:absolute;left:0;top:0;width:100%;transform:translateX(${enterFrom});`;
  const toHeight = nextView.offsetHeight;
  current.style.cssText = 'position:absolute;left:0;top:0;width:100%;transform:translateX(0);';

  root.style.maxHeight = Math.max(fromHeight, toHeight) + 24 + 'px';

  let finished = false;
  const finish = (event) => {
    if (finished) return;
    if (event && event.target !== nextView) return;
    if (event && event.propertyName && event.propertyName !== 'transform') return;
    finished = true;
    nextView.removeEventListener('transitionend', finish);
    current.hidden = true;
    current.style.cssText = '';
    nextView.style.cssText = '';
    stage.style.cssText = '';
    root.dataset.coversAnimating = 'false';
    resizeCoversAccordion(root);
  };

  nextView.addEventListener('transitionend', finish);
  window.setTimeout(finish, 420);

  window.requestAnimationFrame(() => {
    window.requestAnimationFrame(() => {
      stage.style.transition = 'height 320ms ease';
      current.style.transition = 'transform 320ms ease';
      nextView.style.transition = 'transform 320ms ease';
      stage.style.height = toHeight + 'px';
      current.style.transform = `translateX(${exitTo})`;
      nextView.style.transform = 'translateX(0)';
    });
  });
}

function resizeCoversAccordion(root) {
  if (root.getAttribute('aria-hidden') === 'false') {
    root.style.maxHeight = 'none';
    root.style.maxHeight = root.scrollHeight + 'px';
  }
}
